import { DashboardService } from "../dashboardService";
import { LocalStorageService } from "../localStorageService";
import { CreationDateSortOptions, LocalStorageKeys, VendorColumnHeader } from "src/enums";
import { VendorsFiltersState } from "src/types";

class VendorDashService extends DashboardService<
  VendorColumnHeader,
  VendorsFiltersState,
  CreationDateSortOptions,
  undefined
> {
  constructor(localStorageService: LocalStorageService) {
    super(localStorageService, LocalStorageKeys.VENDOR_ACCOUNTS_DASH_SETTINGS);
  }
}

export { VendorDashService };
